module.exports = __webpack_public_path__ + "media/applications/components/ItemApp/assets/images/select-c733c3b5399375eea30f3014d980110e.svg";